/* Defines formatting options for discourse Q&A. */
import moment from 'moment';

/**
 * We have a custom countdown time humanization unsupported by Moment.
 * Format: hh:mm:ss
 * @return {string} human readable form of time in the format of hh:mm:ss
 * maximum time is 30 days
 */
export const countDownTime = function (milliseconds) {
  const duration = moment.duration(milliseconds);

  let seconds = duration.seconds();
  let minutes = duration.minutes();
  let hours = duration.hours() + duration.days() * 24;

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;

  return `${hours}:${minutes}:${seconds}`;
};
